export enum WebhookTabs {
    MANAGE = 'manage',
    EVENTS = 'events',
}
